import { render, staticRenderFns } from "./MmlLiteratureSearchPage.vue?vue&type=template&id=8d0e471a&"
import script from "./MmlLiteratureSearchPage.vue?vue&type=script&lang=js&"
export * from "./MmlLiteratureSearchPage.vue?vue&type=script&lang=js&"
import style0 from "./MmlLiteratureSearchPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports